import { render, staticRenderFns } from "./ConferenceReport.vue?vue&type=template&id=18700140"
import script from "./ConferenceReport.vue?vue&type=script&lang=js"
export * from "./ConferenceReport.vue?vue&type=script&lang=js"
import style0 from "./ConferenceReport.vue?vue&type=style&index=0&id=18700140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports